import React from "react";
import ScanInvoicePrintView from "../views/admin/ScanInvoicePrintView";

const ScanInvoicePrint: React.FC = () => {
    return (
        <div className="ph-10 center" style={{ maxWidth: "450px" }}>
            <ScanInvoicePrintView />
        </div>
    );
};

export default ScanInvoicePrint;